import React, { useEffect, useRef, useState } from 'react'
import { CHATBOT_BLOCK_TYPES } from '../../utils/ChatbotBlockTypes';
import { useDispatch, useSelector } from 'react-redux';
import FileUploader from '../../components/FileUploader';
import AudioRecorder from '../../components/AudioRecorder';
import { getFileMediaId, mediaUploader, uploadFile } from '../../store/actions/globalAction';
import LocationPickerMap from '../../components/LocationPickerMap';
import { getAddress, toTitleCase } from '../../utils/helper';
import TypeableSelect from '../../components/Dropdowns/TypeableSelect';
import { useTranslation } from 'react-i18next';
import DropdownWithAddOption from '../../components/Dropdowns/DropdownWithAddOption';
import Editor from "@monaco-editor/react";
import { agentGroupQuery, getTenantUsers, searchWhatsAppMsgTemplate } from '../../store/actions/tenantAction';
import { v4 as uuidv4 } from 'uuid';
import SetTemplateVariableValue from './SetTemplateVariableValue';
import { onSelectTemplate, setSelectedTemplateMessage } from '../../utils/TemplateHelper';
import WhatsAppTemplatePreview from '../../components/WhatsAppTemplatePreview';

function ChatbotBlocks({ type, allIntent, variables, setVariables, isEdit = false, setBlocks, blockIndex, Blocks }) {
    let dispatch = useDispatch();
    const { t } = useTranslation();
    const editorRef = useRef(null);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState({});
    const [selectedTemplateId, setSelectedTemplateId] = useState();
    const [carouselTemplate, setCarouselTemplate] = useState([]);
    const [template, setTemplate] = useState({
        templateType: "GENERIC",
        category: "MARKETING",
        language: "English",
        header: { type: "HEADER", format: "" },
        body: "",
        footer: "",
        buttons: [],
    });
    const [audioURL, setAudioURL] = useState(null);
    const globalReducer = useSelector((state) => state.globalReducer);
    const [agents, setAgents] = useState([]);
    const [agentGroup, setAgentGroup] = useState([]);
    const [mapLocation, setMapLocation] = useState({
        latitude: 21.4292064,
        longitude: 50.852764,
    });
    const [selectedTemp, setSelectedTemp] = useState({ selectedTemplateId: Blocks[blockIndex]?.selectedTemplateId, templateValue: Blocks[blockIndex]?.templateValue });

    useEffect(() => {
        if (type === CHATBOT_BLOCK_TYPES.BUTTONS) {
            if (!Blocks[blockIndex]?.interactive) {
                setBlockData({ type: type, interactive: { type: "button", body: {}, action: { buttons: [{ type: "reply", reply: { id: `reply-1`, title: "" } }] } } });
            }
        } else if (type === CHATBOT_BLOCK_TYPES.LIST_REPLY) {
            if (!Blocks[blockIndex]?.interactive) {
                setBlockData({ type: type, interactive: { type: "list", body: {}, action: { button: "Send", sections: [{ rows: [{ id: "reply-1-1" }] }] } } });
            }
        } else if (type === CHATBOT_BLOCK_TYPES.API) {
            if (!Blocks[blockIndex]?.api) {
                setBlockData({ type: type, api: { header: [], body: {}, method: "get", responseType: "text/plain", template: {} } });
            }
        } else if (type === CHATBOT_BLOCK_TYPES.SET_ATTRIBUTE) {
            if (!Blocks[blockIndex]?.attributes) {
                setBlockData({ type: type, attributes: [{ action: "set" }] });
            }
        } else if (type === CHATBOT_BLOCK_TYPES.USER_INPUT) {
            if (!Blocks[blockIndex]?.user) {
                setBlockData({ type: type, user: {} });
            }
        } else if (type === CHATBOT_BLOCK_TYPES.REDIRECT) {
            if (!Blocks[blockIndex]?.redirect) {
                setBlockData({ type: type, redirect: { conditions: [] } });
            }
        } else if (type === CHATBOT_BLOCK_TYPES.TICKET) {
            if (!Blocks[blockIndex]?.ticket) {
                setBlockData({ type: type, ticket: { priority: "LOW" } });
            }
        }
        if (isEdit) {
            if (type === CHATBOT_BLOCK_TYPES.LOCATION) {
                setMapLocation({
                    latitude: Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.LOCATION]?.latitude || 21.4292064, longitude: Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.LOCATION]?.longitude || 50.852764,
                    address: Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.LOCATION]?.address || "",
                    name: Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.LOCATION]?.name || ""
                });
            } else if (type === CHATBOT_BLOCK_TYPES.AUDIO) {
                if (Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.AUDIO]?.id) {
                    onFileDownloading(Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.AUDIO]?.id);
                } else if (Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.AUDIO]?.link) {
                    setAudioURL(Blocks[blockIndex]?.[CHATBOT_BLOCK_TYPES.AUDIO]?.link);
                }
            }
        }
        if (type === CHATBOT_BLOCK_TYPES.TICKET) {
            dispatch(getTenantUsers({
                tenantId: globalReducer.loginInfo?.tenantId,
                select: ["uid", "name"],
                filter: [{
                    property: "roles",
                    operator: "IN",
                    not: true,
                    value: ["TENANT_SUPER_ADMIN"],
                }],
                size: 10000,
                offset: 0,
                criteria: { active: true },
                orderBy: [{ property: "createdAt", direction: "ASC" }],
            }, a => setAgents(a.data ?? [])))
            dispatch(agentGroupQuery({
                criteria: {
                    tenantId: globalReducer.loginInfo.tenantId,
                    active: true
                },
                tenantId: globalReducer.loginInfo.tenantId,
                size: 10000,
                offset: 0,
                orderBy: [{ property: "createdAt", direction: "ASC" }],
            }, (d) => setAgentGroup(d?.data)));
        }
        if (type === CHATBOT_BLOCK_TYPES.WHATSAPP_TEMPLATE) {
            if (templates?.length === 0) {
                dispatch(searchWhatsAppMsgTemplate(
                    {
                        tenantId: globalReducer.loginInfo?.tenantId,
                        criteria: {
                            active: true,
                            tenantWabaId: globalReducer.waba?.id,
                            status: "APPROVED",
                        },
                        size: 100000,
                        offset: 0,
                        orderBy: [{ property: "id", direction: "DESC" }]
                    }, (swt) => {
                        setTemplates(swt.data ?? []);
                        if (isEdit) {
                            const st = swt.data?.filter(t => t?.id === Blocks[blockIndex]?.selectedTemplateId)?.[0];
                            setSelectedTemplateId(st?.id ?? null);
                            setSelectedTemplate(st ?? {});
                        }
                    }
                ));
            }
        }
    }, []);

    useEffect(() => {
        if (type === CHATBOT_BLOCK_TYPES.WHATSAPP_TEMPLATE) {
            if (selectedTemplateId === selectedTemp?.selectedTemplateId) {
                if (selectedTemp?.templateValue) {
                    setSelectedTemplateMessage(
                        selectedTemplate,
                        selectedTemp?.templateValue,
                        setTemplate,
                        setCarouselTemplate
                    );
                }
            }
            else if (selectedTemplateId && templates?.length > 0) {
                onSelectTemplate(
                    templates,
                    setSelectedTemplate,
                    setTemplate,
                    setCarouselTemplate,
                    selectedTemplateId
                );
            }
        }
    }, [selectedTemplateId]);

    useEffect(() => {
        if (type === CHATBOT_BLOCK_TYPES.WHATSAPP_TEMPLATE) {
            setBlockData({ type: type, template: template, carouselTemplate: carouselTemplate, selectedTemplateId: selectedTemplateId });
        }
    }, [template, carouselTemplate]);

    const onFileDownloading = (id) => {
        if (id) {
            getFileMediaId(
                globalReducer.waba?.tenantId,
                globalReducer.waba?.id,
                id
            ).then((fd) => {
                setAudioURL(fd);
            });
        }
    };

    const setBlockData = (d) => {
        setBlocks((prev) => {
            let newBlocks = [...prev];
            newBlocks[blockIndex] = d;
            return newBlocks;
        });
    }

    const onEnterName = (e) => {
        let name = e?.toLowerCase()?.replace(/ /g, "_");
        const regex = /^[a-z][a-z0-9_]*$/;
        if (!name || regex.test(name)) {
            return name;
        }
    };

    const uploadAudio = (data) => {
        const formData = new FormData();
        const audioFile = new File(
            [data.audioBlob],
            `recording${new Date().getTime()}.mp3`,
            { type: "audio/mp3" }
        );
        formData.append("file", audioFile);
        const newUuid = uuidv4();
        const key = `template/media/${newUuid}.mp3`;
        dispatch(uploadFile(formData, key, a => {
            if (a) {
                setBlockData({ type: CHATBOT_BLOCK_TYPES.AUDIO, [CHATBOT_BLOCK_TYPES.AUDIO]: { link: process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + key } });
            }
        }));
    };
    const handleLocationChange = ({ latitude, longitude, address, name }) => {
        const updated = { ...mapLocation, latitude, longitude, address, name };
        setMapLocation({ ...updated });
        setBlockData({ type: CHATBOT_BLOCK_TYPES.LOCATION, [CHATBOT_BLOCK_TYPES.LOCATION]: updated });
    };

    const OnInput = (e) => e.target.value = e.target.value.slice(0, e.target.dataset.maxlength);

    const handleEditorChange = (value) => {
        try {
            if (!value.trim()) {
                // If the editor is empty, reset the state with an empty object
                Blocks[blockIndex].api.body = {};
                setBlockData({ ...Blocks[blockIndex] })
                return;
            }
            const parsedValue = JSON.parse(value);
            Blocks[blockIndex].api.body = parsedValue;
            setBlockData({ ...Blocks[blockIndex] })
        } catch (error) {
            console.error("Invalid JSON:", error.message);
        }
    };
    const handleEditorDidMount = (editor) => {
        editorRef.current = editor;
        // Auto-format JSON on load
        setTimeout(() => {
            editor.getAction("editor.action.formatDocument").run();
        }, 100);
    };
    const getBlocakTypes = (ty) => {
        switch (ty) {
            case CHATBOT_BLOCK_TYPES.TEXT:
                return <div className="group relative w-full h-fit m-[2px]">
                    <textarea
                        value={Blocks[blockIndex]?.text}
                        placeholder={`Write your message here`}
                        className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                        required
                        rows={5}
                        data-maxlength={1024}
                        onInput={OnInput}
                        onChange={(e) => {
                            setBlockData({ text: e.target.value, type: CHATBOT_BLOCK_TYPES.TEXT });
                        }}
                    ></textarea>
                    <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                        <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                            {Blocks[blockIndex]?.text?.length}/1024
                        </p>
                    </div>
                </div>;
            case CHATBOT_BLOCK_TYPES.IMAGE:
            case CHATBOT_BLOCK_TYPES.VIDEO:
            case CHATBOT_BLOCK_TYPES.DOCUMENT:
                return <div>
                    <FileUploader
                        wabaId={globalReducer?.waba?.id}
                        tenantId={globalReducer?.waba?.tenantId}
                        isSessionUploder={false} isOwnUploder={true}
                        type={ty}
                        name={Blocks[blockIndex]?.[type]?.filename}
                        selectedFileUrl={Blocks[blockIndex]?.[type]?.thumbnailUrl ?? Blocks[blockIndex]?.[type]?.link}
                        filePrefix="template/media"
                        onUploaded={(file) => {
                            const link = file.url ? process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + file.url : null;
                            if (ty === CHATBOT_BLOCK_TYPES.DOCUMENT) {
                                setBlockData({ type: ty, [ty]: { filename: file.filename, caption: file.filename, thumbnailUrl: file.thumbnailUrl, id: file.id, link: link } });
                            } else {
                                setBlockData({ type: ty, [ty]: { thumbnailUrl: file.thumbnailUrl, id: file.id, link: link } });
                            }
                        }}
                    />
                </div>;
            case CHATBOT_BLOCK_TYPES.AUDIO:
                return <div>
                    {audioURL ? <div className='flex'>
                        <audio controls>
                            <source src={audioURL} type="audio/mp3" />
                            {t("Your browser does not support the audio tag.")}
                        </audio>
                        <button type='button' onClick={() => {
                            setAudioURL(null);
                        }} className='hover:bg-gray-200 text-white px-3 py-2 rounded-lg'>
                            <i className="fa-solid fa-trash-can text-theme"></i>
                        </button>
                    </div> : <AudioRecorder audioData={audioURL} onStop={(data) => uploadAudio(data)} />}
                </div>;
            case CHATBOT_BLOCK_TYPES.LOCATION:
                return <div>
                    <LocationPickerMap value={mapLocation} onChange={handleLocationChange} />
                </div>;
            case CHATBOT_BLOCK_TYPES.BUTTONS:
                return <div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Header Type (Optional)")}</label>
                        <select
                            value={Blocks[blockIndex].interactive?.header?.type}
                            className="border w-full text-[14px] border-gray-300 rounded-md py-2 px-4 cursor-pointer inputEqHeight"
                            onChange={(e) => {
                                Blocks[blockIndex].interactive.header = { type: e.target.value, [e.target.value]: e.target.value === "text" ? "" : {} };
                                setBlockData({ ...Blocks[blockIndex] });
                                if (e.target.value === "") {
                                    delete Blocks[blockIndex].interactive.header;
                                }
                            }}
                        >
                            <option value="" selected className="text-gray-500">{t("None")}</option>
                            <option value="text">{t("Text")}</option>
                            <option value="document">{t("Document")}</option>
                            <option value="image">{t("Image")}</option>
                            <option value="video">{t("Video")}</option>
                        </select>
                        {Blocks[blockIndex]?.interactive?.header?.type === "text" ? <div className='mt-2'>
                            <input type='text' value={Blocks[blockIndex]?.interactive?.header?.text}
                                placeholder={t("Type your header text")} required
                                className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                                data-maxlength={60} onInput={OnInput}
                                onChange={(e) => {
                                    Blocks[blockIndex].interactive.header.text = e.target.value;
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                            <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                                <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                    {Blocks[blockIndex]?.interactive?.header?.text?.length}/60
                                </p>
                            </div>
                        </div> : <div className='mt-2'>
                            <FileUploader
                                wabaId={globalReducer?.waba?.id}
                                tenantId={globalReducer?.waba?.tenantId}
                                isSessionUploder={false} isOwnUploder={true}
                                type={Blocks[blockIndex]?.interactive?.header?.type}
                                name={Blocks[blockIndex]?.interactive?.header?.[Blocks[blockIndex]?.interactive?.header?.type]?.filename}
                                selectedFileUrl={Blocks[blockIndex]?.interactive?.header?.[Blocks[blockIndex]?.interactive?.header?.type]?.thumbnailUrl ?? Blocks[blockIndex]?.interactive?.header?.[Blocks[blockIndex]?.interactive?.header?.type]?.link}
                                filePrefix="template/media"
                                onUploaded={(file) => {
                                    Blocks[blockIndex].interactive.header[Blocks[blockIndex].interactive.header.type] = { filename: file.filename, thumbnailUrl: file.thumbnailUrl, id: file.id, link: file.url ? (process.env.REACT_APP_PRODUCT_APIURL + "/storage/media/file?kay=" + file.url) : null };
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                        </div>}
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Body")}</label>
                        <textarea value={Blocks[blockIndex]?.interactive?.body?.text}
                            placeholder={`Write your message here`}
                            className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                            required rows={5} data-maxlength={1024}
                            onInput={OnInput}
                            onChange={(e) => {
                                Blocks[blockIndex].interactive.body.text = e.target.value
                                setBlockData({ ...Blocks[blockIndex] });
                            }}></textarea>
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.interactive?.body?.text?.length}/1024
                            </p>
                        </div>
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Footer(Optional)")}</label>
                        <input type='text' value={Blocks[blockIndex]?.interactive?.footer?.text}
                            placeholder={t("Type your footer text")}
                            className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                            data-maxlength={60} fonInput={OnInput}
                            onChange={(e) => {
                                if (!Blocks[blockIndex]?.interactive?.footer) {
                                    Blocks[blockIndex].interactive.footer = {};
                                }
                                Blocks[blockIndex].interactive.footer.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                                if (!e.target.value) {
                                    delete Blocks[blockIndex].interactive.footer;
                                }
                            }} />
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.interactive?.footer?.text?.length}/60
                            </p>
                        </div>
                    </div>
                    <div>
                        {Blocks[blockIndex]?.interactive?.action?.buttons?.map((b, i) =>
                            <div className="pt-2 flex gap-2 w-full" key={i}>
                                <div className="text-indigo-400 py-1">{`${i + 1}`}</div>
                                <div className="group relative w-full h-fit">
                                    <input type="text" value={Blocks[blockIndex]?.interactive?.action?.buttons[i]?.reply?.title} placeholder={`Type button title`}
                                        className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                        required data-maxlength={20} onInput={OnInput}
                                        onChange={(e) => {
                                            Blocks[blockIndex].interactive.action.buttons[i].reply.title = e.target.value;
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }}
                                    />
                                    <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-2">
                                        <p className="text-xs bg-green-100 text-green-800 py-1 px-1  rounded">
                                            {Blocks[blockIndex].interactive?.action?.buttons[i]?.reply?.title?.length}/20
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            Blocks[blockIndex].interactive.action.buttons?.splice(i, 1);
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }}
                                        className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-x w-3.5 h-3.5 "
                                        >
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="min-w-[45%]">
                                    <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex].interactive?.action?.buttons[i]?.reply?.id }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                        Blocks[blockIndex].interactive.action.buttons[i].reply.id = s?.intentName ? s?.intentName : `reply-${i + 1}`;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} />
                                </div>
                            </div>
                        )}
                        {Blocks[blockIndex]?.interactive?.action?.buttons?.length != 3 &&
                            <button type="button" onClick={() => {
                                if (!Blocks[blockIndex].interactive?.action) {
                                    Blocks[blockIndex].interactive.action = { buttons: [] };
                                }
                                Blocks[blockIndex].interactive.action.buttons.push({ type: "reply", reply: { id: `reply-${(Blocks[blockIndex].interactive.action.buttons?.length ?? 0) + 1}`, title: "" } });
                                setBlockData({ ...Blocks[blockIndex] });
                            }}
                                className="px-3 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                                <i className="fa-solid fa-plus"></i>
                                {t("Add Button")}
                            </button>
                        }
                    </div>
                    <div className='rounded-md flex h-15 mt-2 bg-gray-50 gap-2'>
                        <div className='items-center gap-2 w-[300px]'>
                            <label className='text-[14px] py-2'>Input Session Expiry</label>
                            <input type='number' value={Blocks[blockIndex]?.interactive?.sessionExpiry}
                                placeholder={`Type session expiry in seconds`}
                                className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                                min={0} onInput={OnInput} data-maxlength={4}
                                onChange={(e) => {
                                    Blocks[blockIndex].interactive.sessionExpiry = parseInt(e.target.value, 10);
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                        </div>
                        <div className='items-center gap-2 w-full'>
                            <label className='text-[14px] py-2'>Action Intent</label>
                            <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.interactive?.userAction }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                Blocks[blockIndex].interactive.userAction = s?.intentName;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                        </div>
                    </div>
                </div>;
            case CHATBOT_BLOCK_TYPES.LIST_REPLY:
                return <div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Header(Optional)")}</label>
                        <input type='text' value={Blocks[blockIndex]?.interactive?.header?.text}
                            placeholder={t("Type your header text")}
                            className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                            data-maxlength={60} onInput={OnInput}
                            onChange={(e) => {
                                if (!Blocks[blockIndex]?.interactive?.header) {
                                    Blocks[blockIndex].interactive.header = { type: "text" };
                                }
                                Blocks[blockIndex].interactive.header.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                                if (!e.target.value) {
                                    delete Blocks[blockIndex].interactive.header;
                                }
                            }} />
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.interactive?.header?.text?.length}/60
                            </p>
                        </div>
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Body")}</label>
                        <textarea value={Blocks[blockIndex]?.interactive?.body?.text}
                            placeholder={`Write your message here`}
                            className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                            required rows={5} data-maxlength={1024} onInput={OnInput}
                            onChange={(e) => {
                                Blocks[blockIndex].interactive.body.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }}></textarea>
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.interactive?.body?.text?.length}/1024
                            </p>
                        </div>
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Footer(Optional)")}</label>
                        <input type='text' value={Blocks[blockIndex]?.interactive?.footer?.text ?? ""}
                            placeholder={t("Type your footer text")}
                            className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                            data-maxlength={60} fonInput={OnInput}
                            onChange={(e) => {
                                if (!Blocks[blockIndex]?.interactive?.footer) {
                                    Blocks[blockIndex].interactive.footer = {};
                                }
                                Blocks[blockIndex].interactive.footer.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                                if (!e.target.value) {
                                    delete Blocks[blockIndex].interactive.footer;
                                }
                            }} />
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.interactive?.footer?.text?.length}/60
                            </p>
                        </div>
                    </div>
                    <div className='w-full'>
                        <label className='text-[14px]'>{t("List Reply Button Text")}</label>
                        <div className="group relative h-fit m-[2px] w-[210px]">
                            <input type='text' value={Blocks[blockIndex].interactive?.action?.button}
                                placeholder={`List Reply Button Text`}
                                className="border border-gray-300 rounded-md px-1.5 w-full py-1.5 text-[14px] skipped"
                                required data-maxlength={20} onInput={OnInput}
                                onChange={(e) => {
                                    Blocks[blockIndex].interactive.action.button = e.target.value;
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                            <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                                <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                    {Blocks[blockIndex].interactive?.action?.button?.length}/20
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        {Blocks[blockIndex]?.interactive?.action?.sections?.map((s, i) => <div key={i} className='gap-2 w-full border px-2 bg-gray-100 mt-2 rounded-md group relative'>
                            <div className="group relative w-full h-fit m-[2px]">
                                <label className='text-[14px]'>{t("Section Title")}</label>
                                <input type='text' value={s?.title}
                                    placeholder={`Type Section Title`}
                                    className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                                    required data-maxlength={24} onInput={OnInput}
                                    onChange={(e) => {
                                        Blocks[blockIndex].interactive.action.sections[i].title = e.target.value;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} />
                                <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                                    <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                        {s?.title?.length}/24
                                    </p>
                                </div>
                            </div>
                            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                                {s?.rows?.map((r, j) =>
                                    <div className="pt-2 gap-2 w-full border p-2 bg-gray-100 mt-2 group rounded-md relative shadow" key={j}>
                                        <div className='flex'>
                                            <div className="text-indigo-400 py-1.5">{`${i + 1}.${j + 1}`}</div>
                                            <div className="group relative w-full h-fit pl-2">
                                                <input type="text" value={r?.title} placeholder={`Type Button Title`}
                                                    className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                                    required data-maxlength={20} onInput={OnInput}
                                                    onChange={(e) => {
                                                        Blocks[blockIndex].interactive.action.sections[i].rows[j].title = e.target.value;
                                                        setBlockData({ ...Blocks[blockIndex] });
                                                    }}
                                                />
                                                <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-2">
                                                    <p className="text-xs bg-green-100 text-green-800 py-1 px-1  rounded">
                                                        {Blocks[blockIndex]?.interactive?.action?.sections[i].rows[j].title?.length}/20
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-full h-fit pl-6 mt-2">
                                            <input type="text" value={r?.description} placeholder={`Type Button Description`}
                                                className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                                data-maxlength={72} onInput={OnInput}
                                                onChange={(e) => {
                                                    Blocks[blockIndex].interactive.action.sections[i].rows[j].description = e.target.value;
                                                    setBlockData({ ...Blocks[blockIndex] });
                                                }}
                                            />
                                            <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-4">
                                                <p className="text-xs bg-green-100 text-green-800 py-1 px-1  rounded">
                                                    {Blocks[blockIndex]?.interactive?.action?.sections[i].rows[j].description?.length}/72
                                                </p>
                                            </div>
                                        </div>
                                        <div className="min-w-[45%] pl-6 mt-2">
                                            <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.interactive?.action?.sections[i].rows[j].id }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                                Blocks[blockIndex].interactive.action.sections[i].rows[j].id = s?.intentName ? s?.intentName : `reply-${i + 1}-${j + 1}`;
                                                setBlockData({ ...Blocks[blockIndex] });
                                            }} />
                                        </div>
                                        <button type="button" onClick={() => {
                                            Blocks[blockIndex]?.interactive?.action?.sections[i].rows?.splice(j, 1);
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }} className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5">
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x w-3.5 h-3.5">
                                                <path d="M18 6 6 18" />
                                                <path d="m6 6 12 12" />
                                            </svg>
                                        </button>
                                    </div>)}
                            </div>
                            {Blocks[blockIndex]?.interactive?.action?.sections[i].rows?.length != 10 &&
                                <button type="button" onClick={() => {
                                    if (!Blocks[blockIndex]?.interactive?.action?.sections[i]?.rows) {
                                        Blocks[blockIndex].interactive.action.sections[i].rows = [];
                                    }
                                    Blocks[blockIndex]?.interactive?.action?.sections[i].rows?.push({ id: `reply-${i + 1}-${(Blocks[blockIndex]?.interactive?.action?.sections[i]?.rows?.length ?? 0) + 1}`, title: "" });
                                    setBlockData({ ...Blocks[blockIndex] });
                                }}
                                    className="px-3 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                                    <i className="fa-solid fa-plus"></i>
                                    {t("Add Button")}
                                </button>
                            }
                            <button type="button" onClick={() => {
                                Blocks[blockIndex]?.interactive?.action?.sections?.splice(i, 1);
                                setBlockData({ ...Blocks[blockIndex] });
                            }} className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5">
                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x w-3.5 h-3.5">
                                    <path d="M18 6 6 18" />
                                    <path d="m6 6 12 12" />
                                </svg>
                            </button>
                        </div>)}
                        {Blocks[blockIndex]?.interactive?.action?.sections?.length != 3 &&
                            <button type="button" onClick={() => {
                                if (!Blocks[blockIndex]?.interactive?.action) {
                                    Blocks[blockIndex].interactive.action = { sections: [] };
                                }
                                Blocks[blockIndex].interactive.action.sections.push({ title: "", rows: [{}] });
                                setBlockData({ ...Blocks[blockIndex] });
                            }} className="px-3 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                                <i className="fa-solid fa-plus"></i>
                                {t("Add Section")}
                            </button>
                        }
                    </div>
                    <div className='rounded-md flex h-15 mt-2 bg-gray-50 gap-2'>
                        <div className='items-center gap-2 w-[300px]'>
                            <label className='text-[14px] py-2'>Input Session Expiry</label>
                            <input type='number' value={Blocks[blockIndex]?.interactive?.sessionExpiry}
                                placeholder={`Type session expiry in seconds`}
                                className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                                min={0} onInput={OnInput} data-maxlength={4}
                                onChange={(e) => {
                                    Blocks[blockIndex].interactive.sessionExpiry = parseInt(e.target.value, 10);
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                        </div>
                        <div className='items-center gap-2 w-full'>
                            <label className='text-[14px] py-2'>Action Intent</label>
                            <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.interactive?.userAction }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                Blocks[blockIndex].interactive.userAction = s?.intentName;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                        </div>
                    </div>
                </div>;
            case CHATBOT_BLOCK_TYPES.API:
                return <div>
                    <p className='text-[12px] text-gray-400'>{t("Provide Title, Method Types and Url for the api.")}</p>
                    <label className='text-[14px] px-2'>{t("Method Type")}</label>
                    <div className='flex gap-2 px-2'>
                        <select required className="p-2 min-h-8 w-[150px] rounded-md border-gray-300" onChange={(e) => {
                            Blocks[blockIndex].api.method = e.target.value;
                            setBlockData({ ...Blocks[blockIndex] });
                        }} value={Blocks[blockIndex]?.api?.method}>
                            <option value="get" selected>{t("Get Method")}</option>
                            <option value="post">{t("Post Method")}</option>
                        </select>
                        <input type="text" value={Blocks[blockIndex]?.api?.url} placeholder={`Enter API URL`}
                            className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                            required data-maxlength={200} onInput={OnInput}
                            onChange={(e) => {
                                Blocks[blockIndex].api.url = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                    </div>
                    <div className='px-2 mt-4'>
                        <p className='text-[14px]'>{t("Header")}</p>
                        <span className='text-[12px] text-gray-400'>{t("Provide Header Information as key value pair below.")}</span>
                    </div>
                    <div className='px-2'>
                        <table className="text-sm text-left text-midBlack w-full overflow-x-auto rounded-md">
                            <thead className="text-[14px] text-midBlack bg-gray-200">
                                <tr>
                                    <th scope="col" className="pb-1 font-[500] pr-2 pl-2">
                                        {t("Key")}
                                    </th>
                                    <th scope="col" className="font-[500] py-3 pl-2">
                                        {t("Value")}
                                    </th>
                                    <th scope="col" className="font-[500] pl-2 w-[50px]">
                                        <button type="button" onClick={() => {
                                            Blocks[blockIndex]?.api?.header?.push({});
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }} className="items-center justify-center whitespace-nowrap text-sm hover:bg-gray-400 bg-gray-300 px-2 py-1.5 rounded-lg">
                                            <i className="fa-solid fa-plus text-theme"></i>
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Blocks[blockIndex]?.api?.header?.map((p, i) => {
                                    return (
                                        <tr className="bg-white border-b" key={i}>
                                            <td className="py-3 px-2 text-[13px] font-normal">
                                                <input type="text" value={p?.key} placeholder={`Key`}
                                                    className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                                                    required
                                                    onChange={(e) => {
                                                        Blocks[blockIndex].api.header[i].key = e.target.value;
                                                        setBlockData({ ...Blocks[blockIndex] });
                                                    }} />
                                            </td>
                                            <td className="py-3 px-2 text-[13px] font-normal">
                                                <input type="text" value={p?.value} placeholder={`Value`}
                                                    className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                                                    required onChange={(e) => {
                                                        Blocks[blockIndex].api.header[i].value = e.target.value;
                                                        setBlockData({ ...Blocks[blockIndex] });
                                                    }} />
                                            </td>
                                            <td className="py-3">
                                                <button type="button" onClick={() => {
                                                    Blocks[blockIndex]?.api?.header?.splice(i, 1);
                                                    setBlockData({ ...Blocks[blockIndex] });
                                                }} className="items-center justify-center whitespace-nowrap text-sm hover:bg-gray-200 bg-gray-100 px-2 py-1.5 rounded-lg">
                                                    <i className="fa-solid fa-trash-can text-theme"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className='px-2 mt-4'>
                        <p className='text-[14px]'>{t("Request Body")}</p>
                        <span className='text-[12px] text-gray-400'>{t("Provide Body Information as JSON below.")}</span>
                    </div>
                    <div className='px-2'>
                        <Editor
                            defaultLanguage="json"
                            ref={editorRef}
                            height="150px"
                            value={JSON.stringify(Blocks[blockIndex]?.api?.body, null, 2) || "{\n\n}"}
                            onChange={handleEditorChange}
                            onMount={handleEditorDidMount}
                            options={{
                                automaticLayout: true,
                                minimap: { enabled: false },
                                formatOnPaste: true,
                                fontSize: 13, // Change font size
                                fontFamily: "Fira Code, monospace", // Custom font
                                minimap: { enabled: false }, // Hide minimap
                                padding: { top: 10 }, // Add padding inside editor
                                lineNumbers: "on", // Show line numbers
                                scrollBeyondLastLine: false,
                            }}
                        />
                    </div>
                    <div className='px-2 mt-4 flex justify-start gap-4'>
                        <div>
                            <p className='text-[14px]'>{t("Response Type")}</p>
                            <select required className="px-2 py-1 min-h-8 min-w-[150px] rounded-md border-gray-300" onChange={(e) => {
                                Blocks[blockIndex].api.responseType = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} value={Blocks[blockIndex]?.api?.responseType}>
                                <option value="text/plain" selected>{t("text/plain")}</option>
                                <option value="image/png">{t("image/png")}</option>
                                <option value="image/jpeg">{t("image/jpeg")}</option>
                                <option value="video/mp4">{t("video/mp4")}</option>
                                <option value="application/pdf">{t("application/pdf")}</option>
                                <option value="application/json">{t("application/json")}</option>
                            </select>
                        </div>
                        {Blocks[blockIndex]?.api?.responseType == "application/json" && <div>
                            <p className='text-[14px]'>{t("Template Type")}</p>
                            <select required className="px-2 py-1 min-h-8 min-w-[150px] rounded-md border-gray-300" onChange={(e) => {
                                Blocks[blockIndex].api.templateType = e.target.value;
                                if (e.target.value === "BUTTONS") {
                                    Blocks[blockIndex].api.template = { type: "button", body: {}, action: { buttons: [{ type: "reply", reply: { id: `reply-1`, title: "" } }] } };
                                } else if (e.target.value === "LIST_REPLY") {
                                    Blocks[blockIndex].api.template = { type: "list", body: {}, action: { button: "Send", sections: [{ rows: [{ id: "reply-1-1" }] }] } };
                                }
                                setBlockData({ ...Blocks[blockIndex] });
                            }} value={Blocks[blockIndex]?.api?.templateType}>
                                <option value="TEXT" selected>{t("Text")}</option>
                                <option value="BUTTONS">{t("Buttons")}</option>
                                <option value="LIST_REPLY">{t("List Reply")}</option>
                                <option value="VIDEO">{t("Video")}</option>
                                <option value="IMAGE">{t("Image")}</option>
                                <option value="DOCUMENT">{t("Pdf")}</option>
                            </select>
                        </div>}
                    </div>
                    {Blocks[blockIndex]?.api?.responseType == "application/json" && <div className='px-2 pt-4'>
                        <p className='text-[14px]'>{t("Json Path")}</p>
                        <p className='text-[12px] text-gray-400'>{`${t("Extract specific data from a JSON document using expressions like $.store.book, $..price, or $.store.books[*].author.")} 
                        ${t("you can test and visualize queries using the")}`} <a className='text-blue-500 hover:underline' href="https://jsonpathfinder.com/" target="_blank" rel="noopener noreferrer">JSONPath Finder</a> {t("tool.")}</p>
                        {getTemplateType(Blocks[blockIndex]?.api?.templateType)}
                    </div>}
                </div>;
            case CHATBOT_BLOCK_TYPES.USER_INPUT:
                return <div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <textarea value={Blocks[blockIndex]?.user?.text}
                            placeholder={`Write your message here`}
                            className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                            required rows={4} data-maxlength={320}
                            onInput={OnInput}
                            onChange={(e) => {
                                Blocks[blockIndex].user.text = e.target.value
                                setBlockData({ ...Blocks[blockIndex] });
                            }}
                        ></textarea>
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.user?.text?.length}/320
                            </p>
                        </div>
                    </div>
                    <div className='border border-gray-300 rounded-md flex h-10 mt-2 bg-gray-50'>
                        <label className='text-[14px] py-2 px-2'>{`{{`}</label>
                        <div className='items-center gap-2 w-full'>
                            <DropdownWithAddOption required={true} height={"37px"} selectedValueField="inputVariable" selected={Blocks[blockIndex]?.user} validChar={/^[a-z0-9_ ]$/} placeholder={t("Set an attribute")} options={variables} setOptions={setVariables} valueField="name" onSelect={(e) => {
                                Blocks[blockIndex].user.inputVariable = e?.name;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                        </div>
                        <label className='text-[14px] py-2 px-2'>{`}}`}</label>
                    </div>
                    <div className='rounded-md flex h-15 mt-2 bg-gray-50 gap-2'>
                        <div className='items-center gap-2 w-[300px]'>
                            <label className='text-[14px] py-2'>Input Session Expiry</label>
                            <input type='number' value={Blocks[blockIndex]?.user?.sessionExpiry}
                                placeholder={`Type session expiry in seconds`} required
                                className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                                min={0} onInput={OnInput} data-maxlength={4}
                                onChange={(e) => {
                                    Blocks[blockIndex].user.sessionExpiry = parseInt(e.target.value, 10);
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                        </div>
                        <div className='items-center gap-2 w-full'>
                            <label className='text-[14px] py-2'>Action Intent</label>
                            <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.user?.action }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                Blocks[blockIndex].user.action = s?.intentName;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                        </div>
                    </div>
                </div>;
            case CHATBOT_BLOCK_TYPES.REDIRECT:
                return <div>
                    <TypeableSelect required={true} height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.redirect?.action }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                        Blocks[blockIndex].redirect.action = s?.intentName;
                        setBlockData({ ...Blocks[blockIndex] });
                    }} />
                    <div className='mt-3'>
                        <div>
                            {Blocks[blockIndex]?.redirect?.conditions?.length == 0 &&
                                <button type="button" onClick={() => {
                                    if (!Blocks[blockIndex]?.redirect?.conditions) {
                                        Blocks[blockIndex].redirect.conditions = [];
                                    }
                                    Blocks[blockIndex]?.redirect?.conditions?.push({ condition: "is", operator: "and" });
                                    setBlockData({ ...Blocks[blockIndex] });
                                }}
                                    className="px-3 bg-gray-100 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                                    <i className="fa-solid fa-plus"></i>
                                    {t("Add Condition")}
                                </button>
                            }
                        </div>
                        {Blocks[blockIndex]?.redirect?.conditions?.map((c, i) =>
                            <div>
                                {i > 0 && <div className='flex justify-start mt-2 w-[130px]'>
                                    <span className={`text-[14px] text-gray-800 px-4 py-2 rounded-l-[7px] cursor-pointer ${c.operator === "and" ? "bg-theme" : "bg-gray-200"}`} onClick={() => {
                                        Blocks[blockIndex].redirect.conditions[i].operator = "and";
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }}>{t("AND")}</span>
                                    <span className='border-l'></span>
                                    <span className={`text-[14px] text-gray-800 px-5 py-2 rounded-e-[7px] cursor-pointer ${c.operator === "or" ? "bg-theme" : "bg-gray-200"}`} onClick={() => {
                                        Blocks[blockIndex].redirect.conditions[i].operator = "or";
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }}>{t("OR")}</span>
                                </div>}
                                <div className='grid grid-cols-5 gap-4 border bg-gray-100 mt-2 px-2 py-4 group relative' key={i}>
                                    <div className='col-span-2'>
                                        <DropdownWithAddOption required={true} height={"37px"} selectedValueField="variable" selected={Blocks[blockIndex]?.redirect?.conditions[i]} validChar={/^[a-z0-9_ ]$/} placeholder={t("Set an attribute")} options={variables} setOptions={setVariables} valueField="name" onSelect={(e) => {
                                            Blocks[blockIndex].redirect.conditions[i].variable = e?.name;
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }} />
                                    </div>
                                    <select required className="px-2 py-1.5 min-h-8 rounded-md border-gray-300" value={Blocks[blockIndex]?.redirect?.conditions[i]?.condition} onChange={(e) => {
                                        Blocks[blockIndex].redirect.conditions[i].condition = e.target.value;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }}>
                                        <option value="is" selected>{t("IS")}</option>
                                        <option value="is_not">{t("IS NOT")}</option>
                                        <option value="contains">{t("CONTAINS")}</option>
                                        <option value="not_contains">{t("NOT CONTAINS")}</option>
                                    </select>
                                    <input type="text" required className="text-[14px] col-span-2 w-full block py-1.5 px-2 w-full text-gray-900 rounded-e-[5px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                        value={Blocks[blockIndex]?.redirect?.conditions[i]?.value} onChange={(e) => {
                                            Blocks[blockIndex].redirect.conditions[i].value = e.target.value;
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }} placeholder="Attribute Value" />
                                    <button type="button" onClick={() => {
                                        Blocks[blockIndex]?.redirect?.conditions?.splice(i, 1);
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x w-3.5 h-3.5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>;
            case CHATBOT_BLOCK_TYPES.SET_ATTRIBUTE:
                return <div className='w-full'>
                    {Blocks[blockIndex]?.attributes?.map((a, i) => {
                        return <div key={i} className='flex gap-2 px-4 w-full mt-2'>
                            <div className='w-full'>
                                <DropdownWithAddOption required={true} height={"37px"} selectedValueField="name" selected={a} validChar={/^[a-z0-9_ ]$/} placeholder={t("Set an attribute")} options={variables} setOptions={setVariables} valueField="name" onSelect={(e) => {
                                    a.name = e?.name;
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                            </div>
                            <div className='flex w-full'>
                                <select required className="px-2 py-1.5 min-h-8 w-[150px] rounded-l-[5px] border-gray-300 border-r-0" value={a?.action} onChange={(e) => {
                                    a.action = e.target.value;
                                    setBlockData({ ...Blocks[blockIndex] });
                                }}>
                                    <option value="set" selected>{t("SET")}</option>
                                    <option value="clear">{t("CLEAR")}</option>
                                </select>
                                <input type="text" required disabled={a?.action === "clear"} className="text-[14px] block py-1.5 px-2 w-full text-gray-900 rounded-e-[5px] border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                    value={a?.value} onChange={(e) => {
                                        a.value = e.target.value;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} placeholder={a?.action === "clear" ? "" : "Attribute Value"} />
                            </div>
                            {i > 0 &&
                                <button type='button' onClick={() => {
                                    Blocks[blockIndex]?.attributes?.splice(i, 1);
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} className='hover:bg-gray-200 text-white px-3 py-2 rounded-lg'>
                                    <i className="fa-solid fa-trash-can text-theme"></i>
                                </button>}
                        </div>;
                    }
                    )}
                    <button type="button" onClick={() => {
                        if (!Blocks[blockIndex]?.attributes) {
                            Blocks[blockIndex].attributes = [];
                        }
                        Blocks[blockIndex].attributes.push({ name: "", action: "set", value: "" });
                        setBlockData({ ...Blocks[blockIndex] });
                    }} className="px-3 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                        <i className="fa-solid fa-plus"></i>
                        {t("Add Attribute")}
                    </button>
                </div>;
            case CHATBOT_BLOCK_TYPES.DELAY:
                return <div className="group relative w-[200px] h-fit m-[2px]">
                    <label className='text-[14px]'>{t("Delay in Seconds")}</label>
                    <input type='number' value={Blocks[blockIndex]?.delayInSeconds}
                        placeholder={`Type delay in seconds`} required
                        className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                        min={0} onInput={OnInput} data-maxlength={4}
                        onChange={(e) => {
                            Blocks[blockIndex].delayInSeconds = parseInt(e.target.value, 10);
                            setBlockData({ ...Blocks[blockIndex] });
                        }} />
                </div>;
            case CHATBOT_BLOCK_TYPES.TICKET:
                return <div className='w-full'>
                    <div className='flex gap-3 w-full justify-between'>
                        <select required className="px-2 py-1.5 min-h-8 w-full rounded-[5px] border-gray-300" value={Blocks[blockIndex]?.ticket?.agentId} onChange={(e) => {
                            if (e.target.options[e.target.selectedIndex].title === "group") {
                                Blocks[blockIndex].ticket.assigned_users = agentGroup.find(ag => ag.id == e.target.value)?.memberIds;
                                Blocks[blockIndex].ticket.assigned_group = { groupId: e.target.value, groupName: e.target.options[e.target.selectedIndex].text };
                            } else {
                                Blocks[blockIndex].ticket.assigned_users = [e.target.value];
                                Blocks[blockIndex].ticket.assigned_group = {};
                            }
                            Blocks[blockIndex].ticket.type = e.target.options[e.target.selectedIndex].title;
                            Blocks[blockIndex].ticket.agentId = e.target.value;
                            setBlockData({ ...Blocks[blockIndex] });
                        }}>
                            <option value="">{t("Select Agent/Group")}</option>
                            <optgroup label={t("Agents")}>
                                {agents?.map((a, i) => <option title='agent' key={i} value={a.uid}>{a.name}</option>)}
                            </optgroup>
                            <optgroup label={t("Groups")}>
                                {agentGroup?.map((a, i) => <option title='group' key={i} value={a.id}>{a.name}</option>)}
                            </optgroup>
                        </select>
                        <select required className="px-2 py-1.5 min-h-8 w-full rounded-[5px] border-gray-300" value={Blocks[blockIndex]?.ticket?.priority} onChange={(e) => {
                            Blocks[blockIndex].ticket.priority = e.target.value;
                            setBlockData({ ...Blocks[blockIndex] });
                        }}>{["LOW", "MEDIUM", "HIGH", "URGENT"].map((priority, i) => <option key={i} value={priority}>{toTitleCase(priority)}</option>)}
                        </select>
                    </div>
                    <div className='mt-2 w-full'>
                        <textarea rows={5} data-maxlength={1024} onInput={OnInput}
                            value={Blocks[blockIndex]?.ticket?.notes} placeholder={`Write your message here`}
                            className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                            onChange={(e) => {
                                Blocks[blockIndex].ticket.notes = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }}
                        ></textarea>
                    </div>
                </div>;
            case CHATBOT_BLOCK_TYPES.WHATSAPP_TEMPLATE:
                return <div className='w-full grid grid-cols-12'>
                    <div className="px-3 py-2 overflow-y-auto col-span-7">
                        <div className="" style={{ height: "calc(-230px + 100vh)" }}>
                            <div className="grid gap-3 w-full pb-2">
                                <div className="w-full">
                                    <label className="text-sm text-gray-600 font-medium" id="headlessui-listbox-label-:rq:">
                                        {t('Message Template')}
                                        <span className="text-red-500 text-[14px]">*</span>
                                    </label>
                                    <TypeableSelect
                                        list={templates}
                                        selected={selectedTemplate}
                                        labelField="name"
                                        valueField="id"
                                        required={true}
                                        placeholder="Select Template"
                                        onSelect={(s) => {
                                            if (s) {
                                                setSelectedTemplateId(s?.id);
                                                setSelectedTemplate(s);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="w-full mt-3 pt-3 border-t border-gray-400 mapDesign">
                                    <label className="block text-sm rtl:text-right text-gray-600 font-medium mb-2">
                                        {t('Set Template Variable Value')}
                                    </label>
                                    <SetTemplateVariableValue
                                        tenantId={globalReducer.loginInfo?.tenantId}
                                        wabaId={globalReducer.waba?.id}
                                        setTemplate={setTemplate}
                                        template={template}
                                        carouselTemplate={carouselTemplate}
                                        setCarouselTemplate={setCarouselTemplate}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative flex flex-col gap-2 items-center bg-white p-2 col-span-5" style={{ height: "calc(-135px + 100vh)" }}>
                        <h1 className="text-[14px] flex justify-end font-medium leading-7 capitalize text-gray-900">
                            {t('Preview')}
                        </h1>
                        <div className="overflow-auto">
                            <WhatsAppTemplatePreview
                                wabaIco={globalReducer.waba?.teamImage}
                                timezone={globalReducer.waba?.timezone}
                                chatPhone={`+${globalReducer.waba?.phoneCode} ${globalReducer.waba?.phone}`}
                                template={template}
                                carouselTemplate={carouselTemplate}
                            />
                        </div>
                    </div>
                </div>;
        }
    }

    const getTemplateType = (type) => {
        switch (type) {
            case "BUTTONS":
                return <div className="mt-2">
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Header Type (Optional)")}</label>
                        <select
                            value={Blocks[blockIndex]?.api?.template?.header?.type}
                            className="border w-full text-[14px] border-gray-300 rounded-md py-2 px-4 cursor-pointer inputEqHeight"
                            onChange={(e) => {
                                Blocks[blockIndex].api.template.header = { type: e.target.value, [e.target.value]: e.target.value === "text" ? "" : {} };
                                setBlockData({ ...Blocks[blockIndex] });
                                if (e.target.value === "") {
                                    delete Blocks[blockIndex].api.template.header;
                                }
                            }}
                        >
                            <option value="" selected className="text-gray-500">{t("None")}</option>
                            <option value="text">{t("Text")}</option>
                            <option value="document">{t("Document")}</option>
                            <option value="image">{t("Image")}</option>
                            <option value="video">{t("Video")}</option>
                        </select>
                        {Blocks[blockIndex]?.api?.template?.header?.type === "text" ? <div className='mt-2'>
                            <input type='text' value={Blocks[blockIndex]?.api?.template?.header?.text}
                                placeholder={t("Type your header text with JSON Path")}
                                required
                                className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                                data-maxlength={60} onInput={OnInput}
                                onChange={(e) => {
                                    Blocks[blockIndex].api.template.header.text = e.target.value;
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                            <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                                <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                    {Blocks[blockIndex]?.api?.template?.header?.text?.length}/60
                                </p>
                            </div>
                        </div> : Blocks[blockIndex]?.api?.template?.header?.type && <div className='mt-1'>
                            <span className='text-[12px] text-gray-500'>{t("Provide your media with JSON Path.")}</span>
                            <div className='flex gap-2'>
                                <select required className="px-2 py-1 min-h-8 min-w-[150px] rounded-md border-gray-300" onChange={(e) => {
                                    Blocks[blockIndex].api.template.header.mediaType = e.target.value;
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} value={Blocks[blockIndex]?.api?.template?.header?.mediaType}>
                                    {Blocks[blockIndex]?.api?.template?.header?.type === "image" && <>
                                        <option value="image/png">{t("image/png")}</option>
                                        <option value="image/jpeg">{t("image/jpeg")}</option>
                                    </>}
                                    {Blocks[blockIndex]?.api?.template?.header?.type === "video" && <>
                                        <option value="video/mp4">{t("video/mp4")}</option>
                                    </>}
                                    {Blocks[blockIndex]?.api?.template?.header?.type === "document" && <>
                                        <option value="application/pdf">{t("application/pdf")}</option>
                                    </>}
                                </select>
                                <input type='text' value={Blocks[blockIndex]?.api?.template?.header?.mediaUrl}
                                    placeholder={t("Enter Media JSON Path")}
                                    required
                                    className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                                    onChange={(e) => {
                                        Blocks[blockIndex].api.template.header.mediaUrl = e.target.value;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} />
                                <input type='text' value={Blocks[blockIndex]?.api?.template?.header?.mediaName}
                                    placeholder={t("Enter Filename with JSON Path")}
                                    required
                                    className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                                    onChange={(e) => {
                                        Blocks[blockIndex].api.template.header.mediaName = e.target.value;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} />
                            </div>
                        </div>}
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Body")}</label>
                        <textarea value={Blocks[blockIndex]?.api?.template?.body?.text}
                            placeholder={`Write your message here with JSON Path`}
                            className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                            required rows={5} data-maxlength={1024}
                            onInput={OnInput}
                            onChange={(e) => {
                                Blocks[blockIndex].api.template.body.text = e.target.value
                                setBlockData({ ...Blocks[blockIndex] });
                            }}></textarea>
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.api?.template?.body?.text?.length}/1024
                            </p>
                        </div>
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Footer(Optional)")}</label>
                        <input type='text' value={Blocks[blockIndex]?.api?.template?.footer?.text}
                            placeholder={t("Type your footer text with JSON Path")}
                            className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                            data-maxlength={60} fonInput={OnInput}
                            onChange={(e) => {
                                if (!Blocks[blockIndex]?.api?.template?.footer) {
                                    Blocks[blockIndex].api.template.footer = {};
                                }
                                Blocks[blockIndex].api.template.footer.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                                if (!e.target.value) {
                                    delete Blocks[blockIndex].api.template.footer;
                                }
                            }} />
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.api?.template?.footer?.text?.length}/60
                            </p>
                        </div>
                    </div>
                    <div className="mt-2">
                        <label className='flex items-center gap-2 cursor-pointer mt-2 max-w-[200px]' htmlFor="isDynamicButtons">
                            <input className="w-4 h-4 text-theme bg-gray-300 shadow-input border-none focus:ring-transparent focus:ring-none" type='checkbox' id="isDynamicButtons" name='isDynamicButtons'
                                checked={Blocks[blockIndex]?.api?.template?.dynamicButtonType === "DYNAMIC"}
                                onChange={(e) => {
                                    Blocks[blockIndex].api.template.dynamicButtonType = e.target.checked ? "DYNAMIC" : "STATIC";
                                    setBlockData({ ...Blocks[blockIndex] });
                                }}
                            />
                            <label htmlFor="isDynamicButtons" className='text-[14px] text-gray-700'>{t("Is Dynamic Buttons")}</label>
                        </label>
                    </div>
                    {Blocks[blockIndex]?.api?.template?.dynamicButtonType === "DYNAMIC" && <div className="mt-2">
                        <label className='text-[14px]'>{t("Enter JSON Path for Buttons List")}</label>
                        <p className='text-[12px] text-gray-400'>{`${t("Extract the button list from a JSON document. The JSONPath expression must return a list (e.g., $.store.books or $.root.books[*])")}`} </p>
                        <input type="text" value={Blocks[blockIndex]?.api?.template?.buttonsEvaluator} placeholder={`Enter JSON Path for Buttons List`}
                            className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped" required
                            onChange={(e) => {
                                Blocks[blockIndex].api.template.buttonsEvaluator = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }}
                        />
                    </div>}
                    <div>
                        {Blocks[blockIndex]?.api?.template?.action?.buttons?.map((b, i) => <div key={i}>
                            <div className="pt-2 flex gap-2 w-full">
                                <div className="text-indigo-400 py-1">{`${i + 1}`}</div>
                                <div className="group relative w-full h-fit">
                                    <input type="text" value={Blocks[blockIndex]?.api?.template?.action?.buttons[i]?.reply?.title} placeholder={`Type button title with JSON Path`}
                                        className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                        required data-maxlength={20} onInput={OnInput}
                                        onChange={(e) => {
                                            Blocks[blockIndex].api.template.action.buttons[i].reply.title = e.target.value;
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }}
                                    />
                                    <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-2">
                                        <p className="text-xs bg-green-100 text-green-800 py-1 px-1  rounded">
                                            {Blocks[blockIndex].api?.template?.action?.buttons[i]?.reply?.title?.length}/20
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            Blocks[blockIndex].api.template.action.buttons?.splice(i, 1);
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }}
                                        className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-x w-3.5 h-3.5 "
                                        >
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="w-full">
                                    <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex].api.template.action.buttons[i]?.reply?.id }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                        Blocks[blockIndex].api.template.action.buttons[i].reply.id = s?.intentName ? s?.intentName : `reply-${i + 1}`;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} />
                                </div>
                            </div>
                            <div className="pt-2 flex gap-2 w-full">
                                <div className='border border-gray-300 rounded-md flex h-9.5 w-full bg-gray-50'>
                                    <label className='text-[14px] py-2 px-2'>{`{{`}</label>
                                    <div className='items-center gap-2 w-full'>
                                        <DropdownWithAddOption required={false} height={"37px"} selectedValueField="inputVariable" selected={Blocks[blockIndex].api.template.action.buttons[i]?.reply} validChar={/^[a-z0-9_ ]$/} placeholder={t("Set an attribute")} options={variables} setOptions={setVariables} valueField="name" onSelect={(e) => {
                                            Blocks[blockIndex].api.template.action.buttons[i].reply.inputVariable = e?.name;
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }} />
                                    </div>
                                    <label className='text-[14px] py-2 px-2'>{`}}`}</label>
                                </div>
                                <input type="text" value={Blocks[blockIndex]?.api?.template?.action?.buttons[i]?.reply?.inputValue} placeholder={`Type input value with JSON Path`}
                                    className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                    onChange={(e) => {
                                        Blocks[blockIndex].api.template.action.buttons[i].reply.inputValue = e.target.value;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }}
                                />
                            </div>
                            <div className='border-b mt-3 mb-1 border-gray-300'></div>
                        </div>
                        )}
                        {Blocks[blockIndex]?.api?.template?.dynamicButtonType === "STATIC" && Blocks[blockIndex]?.api?.template?.action?.buttons?.length != 3 &&
                            <button type="button" onClick={() => {
                                if (!Blocks[blockIndex].api.template?.action) {
                                    Blocks[blockIndex].api.template.action = { buttons: [] };
                                }
                                Blocks[blockIndex].api.template.action.buttons.push({ type: "reply", reply: { id: `reply-${(Blocks[blockIndex].api.template?.action?.buttons?.length ?? 0) + 1}`, title: "" } });
                                setBlockData({ ...Blocks[blockIndex] });
                            }}
                                className="px-3 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                                <i className="fa-solid fa-plus"></i>
                                {t("Add Button")}
                            </button>
                        }
                    </div>
                    <div className='rounded-md flex h-15 mt-2 bg-gray-50 gap-2'>
                        <div className='items-center gap-2 w-[300px]'>
                            <label className='text-[14px] py-2'>Input Session Expiry</label>
                            <input type='number' value={Blocks[blockIndex]?.api?.template?.sessionExpiry}
                                placeholder={`Type session expiry in seconds`}
                                className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                                min={0} onInput={OnInput} data-maxlength={4}
                                onChange={(e) => {
                                    Blocks[blockIndex].api.template.sessionExpiry = parseInt(e.target.value, 10);
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                        </div>
                        <div className='items-center gap-2 w-full'>
                            <label className='text-[14px] py-2'>Action Intent</label>
                            <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.api?.template?.userAction }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                Blocks[blockIndex].api.template.userAction = s?.intentName;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                        </div>
                    </div>
                </div>;
            case "LIST_REPLY":
                return <div className="mt-2">
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Header(Optional)")}</label>
                        <input type='text' value={Blocks[blockIndex]?.api?.template?.header?.text}
                            placeholder={t("Type your header text")}
                            className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                            data-maxlength={60} onInput={OnInput}
                            onChange={(e) => {
                                if (!Blocks[blockIndex]?.api?.template?.header) {
                                    Blocks[blockIndex].api.template.header = { type: "text" };
                                }
                                Blocks[blockIndex].api.template.header.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                                if (!e.target.value) {
                                    delete Blocks[blockIndex].api.template.header;
                                }
                            }} />
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.api?.template?.header?.text?.length}/60
                            </p>
                        </div>
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Body")}</label>
                        <textarea value={Blocks[blockIndex]?.api?.template?.body?.text}
                            placeholder={`Write your message here`}
                            className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                            required rows={5} data-maxlength={1024} onInput={OnInput}
                            onChange={(e) => {
                                Blocks[blockIndex].api.template.body.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }}></textarea>
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.api?.template?.body?.text?.length}/1024
                            </p>
                        </div>
                    </div>
                    <div className="group relative w-full h-fit m-[2px]">
                        <label className='text-[14px]'>{t("Footer(Optional)")}</label>
                        <input type='text' value={Blocks[blockIndex]?.api?.template?.footer?.text ?? ""}
                            placeholder={t("Type your footer text")}
                            className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                            data-maxlength={60} fonInput={OnInput}
                            onChange={(e) => {
                                if (!Blocks[blockIndex]?.api?.template?.footer) {
                                    Blocks[blockIndex].api.template.footer = {};
                                }
                                Blocks[blockIndex].api.template.footer.text = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                                if (!e.target.value) {
                                    delete Blocks[blockIndex].api.template.footer;
                                }
                            }} />
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.api?.template?.footer?.text?.length}/60
                            </p>
                        </div>
                    </div>
                    <div className='w-full'>
                        <label className='text-[14px]'>{t("List Reply Button Text")}</label>
                        <div className="group relative h-fit m-[2px] w-[210px]">
                            <input type='text' value={Blocks[blockIndex].api?.template?.action?.button}
                                placeholder={`List Reply Button Text`}
                                className="border border-gray-300 rounded-md px-1.5 w-full py-1.5 text-[14px] skipped"
                                required data-maxlength={20} onInput={OnInput}
                                onChange={(e) => {
                                    Blocks[blockIndex].api.template.action.button = e.target.value;
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                            <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                                <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                    {Blocks[blockIndex].api?.template?.action?.button?.length}/20
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-2">
                        <label className='flex items-center gap-2 cursor-pointer mt-2 max-w-[200px]' htmlFor="isDynamicButtons">
                            <input className="w-4 h-4 text-theme bg-gray-300 shadow-input border-none focus:ring-transparent focus:ring-none" type='checkbox' id="isDynamicButtons" name='isDynamicButtons'
                                checked={Blocks[blockIndex]?.api?.template?.dynamicButtonType === "DYNAMIC"}
                                onChange={(e) => {
                                    Blocks[blockIndex].api.template.dynamicButtonType = e.target.checked ? "DYNAMIC" : "STATIC";
                                    setBlockData({ ...Blocks[blockIndex] });
                                }}
                            />
                            <label htmlFor="isDynamicButtons" className='text-[14px] text-gray-700'>{t("Is Dynamic Buttons")}</label>
                        </label>
                    </div>
                    {Blocks[blockIndex]?.api?.template?.dynamicButtonType === "DYNAMIC" && <div className="mt-2">
                        <label className='text-[14px]'>{t("Enter JSON Path for Buttons List")}</label>
                        <p className='text-[12px] text-gray-400'>{`${t("Extract the button list from a JSON document. The JSONPath expression must return a list (e.g., $.store.books or $.root.books[*])")}`} </p>
                        <input type="text" value={Blocks[blockIndex]?.api?.template?.buttonsEvaluator} placeholder={`Enter JSON Path for Buttons List`}
                            className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped" required
                            onChange={(e) => {
                                Blocks[blockIndex].api.template.buttonsEvaluator = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }}
                        />
                    </div>}
                    <div>
                        {Blocks[blockIndex]?.api?.template?.action?.sections?.map((s, i) => <div key={i} className='gap-2 w-full border px-2 bg-gray-100 mt-2 rounded-md group relative'>
                            <div className="group relative w-full h-fit m-[2px]">
                                <label className='text-[14px]'>{t("Section Title")}</label>
                                <input type='text' value={s?.title}
                                    placeholder={`Type Section Title`}
                                    className="border border-gray-300 rounded-md px-1.5 py-2 w-[100%] text-[14px] skipped"
                                    required data-maxlength={24} onInput={OnInput}
                                    onChange={(e) => {
                                        Blocks[blockIndex].api.template.action.sections[i].title = e.target.value;
                                        setBlockData({ ...Blocks[blockIndex] });
                                    }} />
                                <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                                    <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                        {s?.title?.length}/24
                                    </p>
                                </div>
                            </div>
                            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                                {s?.rows?.map((r, j) =>
                                    <div className="pt-2 gap-2 w-full border p-2 bg-gray-100 mt-2 group rounded-md relative shadow" key={j}>
                                        <div className='flex'>
                                            <div className="text-indigo-400 py-1.5">{`${i + 1}.${j + 1}`}</div>
                                            <div className="group relative w-full h-fit pl-2">
                                                <input type="text" value={r?.title} placeholder={`Type Button Title`}
                                                    className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                                    required data-maxlength={20} onInput={OnInput}
                                                    onChange={(e) => {
                                                        Blocks[blockIndex].api.template.action.sections[i].rows[j].title = e.target.value;
                                                        setBlockData({ ...Blocks[blockIndex] });
                                                    }}
                                                />
                                                <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-2">
                                                    <p className="text-xs bg-green-100 text-green-800 py-1 px-1  rounded">
                                                        {Blocks[blockIndex]?.api?.template?.action?.sections[i].rows[j].title?.length}/20
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-full h-fit pl-6 mt-2">
                                            <input type="text" value={r?.description} placeholder={`Type Button Description`}
                                                className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                                data-maxlength={72} onInput={OnInput}
                                                onChange={(e) => {
                                                    Blocks[blockIndex].api.template.action.sections[i].rows[j].description = e.target.value;
                                                    setBlockData({ ...Blocks[blockIndex] });
                                                }}
                                            />
                                            <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-center pr-4">
                                                <p className="text-xs bg-green-100 text-green-800 py-1 px-1  rounded">
                                                    {Blocks[blockIndex]?.api?.template?.action?.sections[i].rows[j].description?.length}/72
                                                </p>
                                            </div>
                                        </div>
                                        <div className="min-w-[45%] pl-6 mt-2">
                                            <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.api?.template?.action?.sections[i].rows[j].id }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                                Blocks[blockIndex].api.template.action.sections[i].rows[j].id = s?.intentName ? s?.intentName : `reply-${i + 1}-${j + 1}`;
                                                setBlockData({ ...Blocks[blockIndex] });
                                            }} />
                                        </div>
                                        <div className='border border-gray-300 rounded-md flex h-9.5 bg-gray-50 ml-6 mt-2'>
                                            <label className='text-[14px] py-2 px-2'>{`{{`}</label>
                                            <div className='items-center gap-2 w-full'>
                                                <DropdownWithAddOption required={false} height={"37px"} selectedValueField="inputVariable" selected={Blocks[blockIndex]?.api?.template?.action?.sections[i].rows[j]} validChar={/^[a-z0-9_ ]$/} placeholder={t("Set an attribute")} options={variables} setOptions={setVariables} valueField="name" onSelect={(e) => {
                                                    Blocks[blockIndex].api.template.action.sections[i].rows[j].inputVariable = e?.name;
                                                    setBlockData({ ...Blocks[blockIndex] });
                                                }} />
                                            </div>
                                            <label className='text-[14px] py-2 px-2'>{`}}`}</label>
                                        </div>
                                        <div className='pl-6 mt-2'>
                                            <input type="text" value={Blocks[blockIndex]?.api?.template?.action?.sections[i].rows[j]?.inputValue} placeholder={`Type input value with JSON Path`}
                                                className="border border-gray-300 rounded-md py-1.5 px-1.5 w-[100%] text-[14px] skipped"
                                                onChange={(e) => {
                                                    Blocks[blockIndex].api.template.action.sections[i].rows[j].inputValue = e.target.value;
                                                    setBlockData({ ...Blocks[blockIndex] });
                                                }}
                                            />
                                        </div>
                                        <button type="button" onClick={() => {
                                            Blocks[blockIndex]?.api?.template?.action?.sections[i].rows?.splice(j, 1);
                                            setBlockData({ ...Blocks[blockIndex] });
                                        }} className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5">
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x w-3.5 h-3.5">
                                                <path d="M18 6 6 18" />
                                                <path d="m6 6 12 12" />
                                            </svg>
                                        </button>
                                    </div>)}
                            </div>
                            {Blocks[blockIndex]?.api?.template?.dynamicButtonType === "STATIC" && Blocks[blockIndex]?.api?.template?.action?.sections[i].rows?.length != 10 &&
                                <button type="button" onClick={() => {
                                    if (!Blocks[blockIndex]?.api?.template?.action?.sections[i]?.rows) {
                                        Blocks[blockIndex].api.template.action.sections[i].rows = [];
                                    }
                                    Blocks[blockIndex]?.api?.template?.action?.sections[i].rows?.push({ id: `reply-${i + 1}-${(Blocks[blockIndex]?.api?.template?.action?.sections[i]?.rows?.length ?? 0) + 1}`, title: "" });
                                    setBlockData({ ...Blocks[blockIndex] });
                                }}
                                    className="px-3 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                                    <i className="fa-solid fa-plus"></i>
                                    {t("Add Button")}
                                </button>
                            }
                            <button type="button" onClick={() => {
                                Blocks[blockIndex]?.api?.template?.action?.sections?.splice(i, 1);
                                setBlockData({ ...Blocks[blockIndex] });
                            }} className="items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow absolute hidden group-hover:block top-[-8px] right-[-8px] hover:bg-red-500 hover:text-white h-fit rounded-full border text-[#374151] border-gray-300 bg-white p-0.5">
                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x w-3.5 h-3.5">
                                    <path d="M18 6 6 18" />
                                    <path d="m6 6 12 12" />
                                </svg>
                            </button>
                        </div>)}
                        {Blocks[blockIndex]?.api?.template?.dynamicButtonType === "STATIC" && Blocks[blockIndex]?.api?.template?.action?.sections?.length != 3 &&
                            <button type="button" onClick={() => {
                                if (!Blocks[blockIndex]?.api?.template?.action) {
                                    Blocks[blockIndex].api.template.action = { sections: [] };
                                }
                                Blocks[blockIndex].api.template.action.sections.push({ title: "", rows: [{}] });
                                setBlockData({ ...Blocks[blockIndex] });
                            }} className="px-3 py-2 my-2 flex gap-2 items-center border rounded-md border-gray-300 hover:text-theme hover:border-theme text-sm font-medium text-gray-700">
                                <i className="fa-solid fa-plus"></i>
                                {t("Add Section")}
                            </button>
                        }
                    </div>
                    <div className='rounded-md flex h-15 mt-2 bg-gray-50 gap-2'>
                        <div className='items-center gap-2 w-[300px]'>
                            <label className='text-[14px] py-2'>Input Session Expiry</label>
                            <input type='number' value={Blocks[blockIndex]?.api?.template?.sessionExpiry}
                                placeholder={`Type session expiry in seconds`}
                                className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                                min={0} onInput={OnInput} data-maxlength={4}
                                onChange={(e) => {
                                    Blocks[blockIndex].api.template.sessionExpiry = parseInt(e.target.value, 10);
                                    setBlockData({ ...Blocks[blockIndex] });
                                }} />
                        </div>
                        <div className='items-center gap-2 w-full'>
                            <label className='text-[14px] py-2'>Action Intent</label>
                            <TypeableSelect height={"37px"} list={allIntent} selected={{ intentName: Blocks[blockIndex]?.api?.template?.userAction }} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                                Blocks[blockIndex].api.template.userAction = s?.intentName;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                        </div>
                    </div>
                </div>;
            case "VIDEO":
            case "IMAGE":
            case "DOCUMENT":
                return <div className="mt-2">
                    <label className='text-[14px]'>{t("Enter JSON Path for Media URL")}</label>
                    <p className='text-[12px] text-gray-400'>{`${t("Extract the media URL from a JSON document. The JSONPath expression must return a string (e.g., $.store.url, $.store.books[0].url)")}`} </p>
                    <div className='flex gap-2'>
                        <input type='text' value={Blocks[blockIndex]?.api?.template?.mediaUrl}
                            placeholder={t("Enter Media JSON Path")}
                            required
                            className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                            onChange={(e) => {
                                Blocks[blockIndex].api.template.mediaUrl = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                        <input type='text' value={Blocks[blockIndex]?.api?.template?.mediaName}
                            placeholder={t("Enter Filename with JSON Path")}
                            required
                            className="border border-gray-300 rounded-md px-1.5 py-1.5 w-[100%] text-[14px] skipped"
                            onChange={(e) => {
                                Blocks[blockIndex].api.template.mediaName = e.target.value;
                                setBlockData({ ...Blocks[blockIndex] });
                            }} />
                    </div>
                </div>;
            default:
                return <div className="mt-2">
                    <div className="group relative w-full h-fit m-[2px]">
                        <textarea
                            value={Blocks[blockIndex]?.api?.template?.text}
                            placeholder={`Write your message here with JSON Path`}
                            className="border border-gray-300 rounded-md p-1 w-[100%] text-[14px] skipped"
                            required
                            rows={5}
                            data-maxlength={1024}
                            onInput={OnInput}
                            onChange={(e) => {
                                Blocks[blockIndex].api.template = { text: e.target.value };
                                setBlockData({ ...Blocks[blockIndex] });
                            }}
                        ></textarea>
                        <div className="pointer-events-none absolute inset-y-0 right-0 rtl:left-2 flex items-end pr-2">
                            <p className="text-xs bg-green-100 text-green-800 mb-2 py-1 px-1 rounded">
                                {Blocks[blockIndex]?.api?.template?.text?.length}/1024
                            </p>
                        </div>
                    </div>
                </div>;
        }
    };

    return (
        <div>
            {getBlocakTypes(type)}
        </div>
    )
}

export default ChatbotBlocks